export enum MaintenanceLogModalType {
	CREATE = 'CREATE',
	DELETE = 'DELETE',
	EDIT = 'EDIT',
	PENDING = 'PENDING',
	RESOLVE = 'RESOLVE'
}
